// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"ff00c2f7","453":"0437a03d","702":"e191be29"}[chunkId] + ".chunk.js";
};